import BaseModel from "./BaseModels/BaseModel";


export class DnsCreateTXTRequest  {
    prefix?: string;
    suffix_id = "";
    value = "";
}

export class DnsCreateTXTResponse extends BaseModel {
    fqdn?: string;
    value?: string;
    ttl?: number;   
}